/* eslint-disable @typescript-eslint/naming-convention */
export class DbTaellevaerkType {
    public BESKRIV: string;
    public INDEXNAVN: string;
    public ENHED_TEXT: string;
    public ENHED: number;
    public FAKTOR: string;
    public FORMAT: string;
    public DECIMALER: number;
}
